import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="newspaper-1, guide, info, faq, book"><path d="M11.25 5.127L6.56611 4.08262C4.22348 3.56028 2 5.34259 2 7.74274V16.0329C2 17.7895 3.21938 19.3107 4.93389 19.693L11.25 21.1013V5.127Z" fill="currentColor"/><path d="M12.75 5.127V21.1013L19.0661 19.693C20.7806 19.3107 22 17.7895 22 16.0329V7.74274C22 5.34259 19.7765 3.56028 17.4339 4.08262L12.75 5.127Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNewspaper1;
